import { ArrowUpRight, Mail, MapPin, MessageCircle, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { serviceGroups, site } from "../data/site";

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-foreground-950 text-white">
      <div className="section-shell grid gap-10 py-14 md:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <img src={site.logo} alt="Polishing Singapore" className="mb-5 h-11 w-auto rounded-sm bg-white p-1" />
          <p className="max-w-md text-sm leading-7 text-background-200">{site.heroLead}</p>
          <a className="mt-5 inline-flex items-center gap-2 text-sm font-bold text-primary-200" href={site.whatsappUrl}>
            <MessageCircle size={15} />
            {site.phone}
            <ArrowUpRight size={15} />
          </a>
        </div>

        <div>
          <h2 className="mb-4 font-heading text-lg font-bold">Surface Types</h2>
          <div className="grid gap-2 text-sm text-background-200">
            {serviceGroups.slice(0, 8).map((group) => (
              <Link key={group.slug} to={`/services#${group.slug}`} className="hover:text-white">
                {group.name}
              </Link>
            ))}
          </div>
        </div>

        <div>
          <h2 className="mb-4 font-heading text-lg font-bold">Contact</h2>
          <div className="grid gap-3 text-sm text-background-200">
            <a href={site.phoneHref} className="flex items-start gap-3 hover:text-white">
              <Phone className="mt-0.5 shrink-0 text-primary-300" size={15} />
              {site.phone}
            </a>
            <a href={`mailto:${site.email}`} className="flex items-start gap-3 hover:text-white">
              <Mail className="mt-0.5 shrink-0 text-primary-300" size={15} />
              {site.email}
            </a>
            <div className="flex items-start gap-3">
              <MapPin className="mt-0.5 shrink-0 text-primary-300" size={15} />
              <span>{site.address.join(", ")}</span>
            </div>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="section-shell flex flex-col gap-3 py-5 text-xs text-background-300 md:flex-row md:items-center md:justify-between">
          <p>© {new Date().getFullYear()} {site.brand}. Stone polishing, restoration and cleaning in Singapore.</p>
          <p>Material-specific pages for stone, tile, parquet and concrete care.</p>
        </div>
      </div>
    </footer>
  );
}
